import { getGeoCache } from './geo-cache';

export const isAddressCached = (address, cache) => {
  return !!getGeoCache(address, cache);
}
